module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 item-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 item-right"
  }, [(_vm.showLogin) ? _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    attrs: {
      "id": "Logo"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Login")]), _vm._v(" "), _c('p', [_vm._v("Please enter your email and password to login")]), _vm._v(" "), (_vm.ErrorMessage == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n          Please enter the fields marked *\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Enter Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "id": "LoginButton"
    },
    on: {
      "click": function($event) {
        _vm.UserLogin()
      }
    }
  }, [_vm._v("\n          Login\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.LoginError == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n            Sorry, please check the above details and try again\n          ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.showLogin) ? _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    attrs: {
      "id": "Logo"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.name),
      expression: "userModel.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputEmail",
      "placeholder": "Enter Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.email),
      expression: "userModel.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Enter Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.mobile),
      expression: "userModel.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputEmail",
      "placeholder": "Enter Mobile",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.password),
      expression: "userModel.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "id": "LoginButton"
    },
    on: {
      "click": function($event) {
        _vm.UserSignUp()
      }
    }
  }, [_vm._v("\n          Sign up\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.LoginError == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n            Sorry, please check the above details and try again\n          ")]) : _vm._e()])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d9f27a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1472
// module chunks = 1